const constants = require('@/util/constants')
require('./config')

/**
 * 获取帮助文档
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getArticlesDynamics(queryParam, successcb, failedcb) {
  axios.get('/api/article/dynamics', {
    params: {
      'cid': queryParam.cid,
      'page': queryParam.page,
      'size': queryParam.size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getArticlesSupport(queryParam, successcb, failedcb) {
  axios.get('/api/article/support', {
    params: {
      'categoryId': queryParam.categoryId,
      'page': queryParam.page,
      'size': queryParam.size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getArticlesKnowledge(queryParam, successcb, failedcb) {
  axios.get('/api/article/knowledge', {
    params: {
      'categoryId': queryParam.categoryId,
      'page': queryParam.page,
      'size': queryParam.size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function createArticle(article, successcb, failedcb) {
  axios.post('/api/article/create', {
    type: article.type,
    title: article.title,
    recommend: article.recommend,
    top: article.top,
    published: article.published,
    categories: article.categories,
    summary: article.summary,
    markdown: article.markdown,
    content: article.content,
    attachments: article.attachments,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function updateArticle(article, successcb, failedcb) {
  axios.post('/api/article/update', {
    id: article.id,
    title: article.title,
    recommend: article.recommend,
    top: article.top,
    published: article.published,
    categories: article.categories,
    summary: article.summary,
    markdown: article.markdown,
    content: article.content,
    attachments: article.attachments,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// 发布、上架
export function publishArticle(id, successcb, failedcb) {
  axios.post('/api/article/publish', {
    id: id,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// 下架
export function offlineArticle(id, successcb, failedcb) {
  axios.post('/api/article/offline', {
    id: id,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function deleteArticle(id, successcb, failedcb) {
  axios.post('/api/article/delete', {
    id: id,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function filterArticle(page, size, content, successcb, failedcb) {
  axios.get('/api/article/filter', {
    params: {
      'page': page,
      'size': size,
      'content': content,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建帮助文档
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function createSupportArticle (title, content, recommend, markdown, categories, successcb, failedcb) {
//   axios.post('/api/article/create', {
//     title,
//     content,
//     recommend,
//     markdown,
//     categories,
//     client: constants.HTTP_CLIENT
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

/**
 * 更新帮助文档
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function updateSupportArticle (articleId, title, content, recommend, markdown, categories, successcb, failedcb) {
//   axios.post('/api/article/update', {
//     articleId,
//     title,
//     content,
//     recommend,
//     markdown,
//     categories,
//     client: constants.HTTP_CLIENT
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

/**
 * 删除帮助文档类别
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function deleteSupportArticle (articleId, successcb, failedcb) {
//   axios.post('/api/article/delete', {
//     articleId: articleId,
//     client: constants.HTTP_CLIENT
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }
